import React from "react";
import styled from "styled-components";
import { Facebook, Instagram, Pinterest, Twitter } from "@material-ui/icons";
import { mobile, mobileM, tablet, laptop } from "../responsive";
//
//
const WrapperFooter = styled.div`
  width: 100vw;
  min-height: 20vh;
  //
  overflow: hidden;

  /*  */
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  //
  //
  padding: 20px 0 0 0;
  border-radius: 107px 107px 0px 0px;
  background-color: rgb(248, 248, 248);
  border: 5px solid #121212;
`;
//
const Container = styled.div`
  padding: 20px 30px;
  height: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  //
  background-color: rgb(248, 248, 248);
  font-size: calc(4px + 1.1vmin);
  color: #121212;

  //
  //
  ${mobile({
    flexDirection: "column",
    minHeight: "15vh",
    padding: "70px 0 70px 0",
    fontSize: `calc(10px + 1.1vmin)`,
  })}
  ${mobileM({
    flexDirection: "column",
    // padding: "70px 0 70px 0",
    // minHeight: "15vh",
    fontSize: `calc(10px + 1.1vmin)`,
    lineHeight: `calc(18px + 1.1vmin)`,
  })}
      ${tablet({})}
       ${laptop({})}
`;
//
//
const Left = styled.div`
  // *** nadia mariduena TEXT

  flex: 1;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 100;
`;
const Text = styled.div`
  margin: 0 0 0 20px;
  font-family: "Syncopate-Bold";

  ${mobile({ marginTop: "20px" })}
  ${mobileM({ marginTop: "20px" })}
  ${tablet({})}
`;

//
//
//
const Center = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-around;
  align-items: flex-end;
  flex-direction: row;
  overflow: hidden;
`;

const SocialContainer = styled.div`
  display: flex;

  ${mobile({
    margin: "20px 0",
  })}
  ${mobileM({
    margin: "20px 0",
  })}
  ${tablet({})}
`;
const SocialIcon = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 50%;

  margin: 0 10px;
  ${mobile({
    marginTop: "20px",
    width: "25px",
    height: "25px",
  })}
  ${mobileM({})}
  ${tablet({})}
`;

//
//
const Right = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;

  ${mobile({ flexDirection: "column" })}
  ${mobileM({
    flex: "1",
  })}
  ${tablet({ flexDirection: "column", flex: "1" })}
  ${laptop({ flex: "2" })}
`;
const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none; //will remove the dot of the list
  display: flex;
  flex-wrap: nowrap; //will position in column
  ${mobile({
    margin: "20px 0 0 0 ",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    lineHeight: "20px",
  })}
  ${mobileM({
    margin: "20px 0 0 0 ",

    display: "flex",
    justifyContent: "flex-between",
    alignItems: "center",
    textAlign: "center",
    flexDirection: "column",
  })}
  ${tablet({})}
  ${laptop({})}
`;

const ListItem = styled.li`
  margin: 0 10px 0 10px;
  font-family: "Syncopate-Bold";

  text-transform: uppercase;
  letter-spacing: 2px;
`;
//
//

const Footer = () => {
  //
  //
  //
  return (
    <WrapperFooter>
      {" "}
      <Container>
        <Left>
          <Text> Nadia Mariduena © 2021</Text>
        </Left>
        <Center>
          {" "}
          <SocialContainer>
            <SocialIcon>
              <Facebook />
            </SocialIcon>
            {/*  */}
            <SocialIcon>
              <Instagram />
            </SocialIcon>
            {/*  */}
            <SocialIcon>
              <Twitter />
            </SocialIcon>
            {/*  */}
            <SocialIcon>
              <Pinterest />
            </SocialIcon>
          </SocialContainer>
        </Center>
        {/* ------- */}
        <Right>
          <List>
            <ListItem>Terms and conditions</ListItem>
            <ListItem>Privacy notice</ListItem>
            <ListItem>Consumer information</ListItem>
          </List>
        </Right>
      </Container>
    </WrapperFooter>
  );
};

export default Footer;
